export const supplierContractFamilySearch = (searchParams: URLSearchParams) => {
  const supplierContractFolderId = searchParams.get("supplierContractFolderId")?.trim();
  const supplierId = searchParams.get("supplierId")?.trim();

  if (!supplierContractFolderId || !supplierId) return "";

  return `?${new URLSearchParams({ supplierContractFolderId, supplierId }).toString()}`;
};

/** True when the URL is a Contract Family link (Supplier or Renewal Centre) rather than My Folders browsing. */
export const isContractFamilyLink = (searchParams: URLSearchParams) =>
  supplierContractFamilySearch(searchParams) !== "";
